import { useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import type { ActivityDetailOut } from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import { ACTIVITY_DEFAULT_TAB, ACTIVITY_SHOW_TABS } from '../constants';
import { ActivityShowHeader } from './ActivityShowHeader';
import { ActivityGeneralTab } from './ActivityGeneralTab';

export const ActivityShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<ActivityDetailOut>({
    resource: 'system.activities',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  useRecordDocumentTitle(
    'system.activities',
    record ? `${record.verb ?? ''} #${record.id}`.trim() : undefined
  );

  const [activeTab, onTabChange] = useShowTab(
    ACTIVITY_SHOW_TABS,
    ACTIVITY_DEFAULT_TAB
  );

  return (
    <Show isLoading={isLoading} contentProps={bareShowContentProps}>
      {record && (
        <>
          <ActivityShowHeader
            record={record}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && <ActivityGeneralTab record={record} />}
          </div>
        </>
      )}
    </Show>
  );
};
